<template>
  <div class="overflow-x-hidden scroll-smooth">
    <!-- header start-->
    <section class="w-full h-full">
      <div
        class="bg-gradient-to-b from-[#0f2477] to-[#28448d] py-4 lg:py-4 px-5"
      >
        <div class="w-full lg:w-[95%] 2xl:w-[90%] mx-auto">
          <a href="tel:+918422841076">
            <div class="hidden md:flex justify-between items-center">
              <img
                src="@/assets/mba/JO-logo.webp"
                alt="Jain-online"
                srcset=""
                class="md:h-[40px] lg:h-[50px]"
              />
              <p
                class="text-[#f8c300] py-3 text-[20px] rounded-3xl flex gap-2 items-center"
              >
                <img src="@/assets/mba/call-icon.webp" alt="call-icon" />
                +91 8422841076
              </p>
            </div>
          </a>
          <div class="flex justify-between items-center md:hidden">
            <img
              src="@/assets/mba/JO-logo.webp"
              alt=""
              srcset=""
              class="w-[180px] h-[30px]"
            />
            <a href="tel:+918422841076" class="bg-white rounded-full p-1">
              <img
                src="@/assets/mba/call-icon.webp"
                alt="call-icon text-black w-4 h-4"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- header end-->
    <section class="pb-3 md:pb-6 lg:pb-8">
      <div
        class="hidden md:block bg-[#123177] lg:h-[580px] 2xl:h-[600px] px-5 py-2 md:py-0 md:px-4 2xl:p-0 relative"
      >
        <!-- Desktop Banner -->
        <div
          class="w-full lg:w-[95%] 2xl:w-[90%] lg:h-[560px] 2xl:h-[660px] mx-auto"
        >
          <div class="hidden lg:flex lg:justify-between items-center h-full">
            <!-- content -->
            <div class="flex flex-col gap-4 pb-[80px] lg:w-[450px]">
              <h1 class="text-[35px] text-left font-bold text-white">
                Online MBA Degree Program
              </h1>
              <p
                class="font-semibold 2xl:w-[368px] py-1 rounded-lg text-[18px]"
              ></p>

              <ul class="text-white flex flex-col gap-3 list-inside">
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[18px]">Live Interactive Classes</p>
                </div>
              </ul>
              <ul class="text-white flex flex-col gap-3 list-inside">
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[18px]">Industry-Oriented Curriculum</p>
                </div>
              </ul>
              <ul class="text-white flex flex-col gap-3 list-inside">
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[18px]">No-Cost EMI Options</p>
                </div>
              </ul>
              <ul class="text-white flex flex-col gap-3 list-inside">
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[18px]">2000+ Hiring Corporates</p>
                </div>
              </ul>
              <div class="flex gap-2">
                <img
                  src="@/assets/mba/banner-icon1.webp"
                  alt="NAAC-icon"
                  srcset=""
                  class="w-[80px] object-contain"
                />
                <img
                  src="@/assets/mba/banner-icon2.webp"
                  alt="AICTE-icon"
                  srcset=""
                  class="w-[80px] object-contain"
                />
                <img
                  src="@/assets/mba/banner-icon3.webp"
                  alt="AUAP-icon"
                  srcset=""
                  class="w-[80px] object-contain"
                />
                <img
                  src="@/assets/mba/banner-icon4.webp"
                  alt="WUR-icon"
                  srcset=""
                  class="w-[80px] object-contain"
                />
              </div>
            </div>
            <!-- banner image -->
            <div class="flex justify-center">
              <div class="absolute top-0">
                <img
                  alt="banner-image"
                  class="w-[350px] 2xl:w-[400px] h-[630px] object-cover rounded-b-3xl"
                  src="@/assets/mba/girl.webp"
                />
              </div>
            </div>

            <!--Enquire form -->
            <div
              class="hidden pt-5 lg:flex justify-center items-center relative left-[5%]"
            >
              <div class="" data-height="480px" style="width: 500px">
                <iframe
                  :src="iframeSrc"
                  width="340"
                  height="550px"
                  frameborder="0"
                  class="overflow-hidden"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Banner -->
      <div class="w-full lg:hidden bg-[#123177]">
        <div class="md:w-[500px] mx-auto flex flex-col gap-3 px-5 py-4">
          <div class="flex flex-col gap-2 px-2">
            <!-- content -->
            <h1 class="text-[25px] font-bold text-white">
              Online MBA Degree Program
            </h1>
            <p class="font-semibold py-1 rounded-lg text-[14px]"></p>
            <div class="mt-3 flex flex-col justify-center mx-auto gap-3">
              <ul class="text-white pl-4 list-inside">
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[20px]">Live Interactive Classes</p>
                </div>
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[20px]">Industry-Oriented Curriculum</p>
                </div>
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[20px]">No-Cost EMI Options</p>
                </div>
                <div class="flex gap-2 items-center">
                  <img
                    src="@/assets/mba/white-check.webp"
                    alt=""
                    srcset=""
                    class="w-4 h-4"
                  />
                  <p class="text-[20px]">2000+ Hiring Corporates</p>
                </div>
              </ul>
              <div class="flex justify-center gap-2">
                <img
                  src="@/assets/mba/banner-icon1.webp"
                  alt="NAAC-icon"
                  srcset=""
                  class="w-16 h-16 object-contain"
                />
                <img
                  src="@/assets/mba/banner-icon2.webp"
                  alt="AICTE-icon"
                  srcset=""
                  class="w-16 h-16 object-contain"
                />
                <img
                  src="@/assets/mba/banner-icon3.webp"
                  alt="AUAP-icon"
                  srcset=""
                  class="w-16 h-16 object-contain"
                />
                <img
                  src="@/assets/mba/banner-icon4.webp"
                  alt="WUR-icon"
                  srcset=""
                  class="w-16 h-16 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        <!--Enquire form -->
        <div class="w-full mt-5 pb-4 flex justify-center items-center">
          <div class="sm:w-[411px] md:w-[500px] mx-auto overflow-hidden">
            <div class="overflow-hidden" data-height="470px" width="380">
              <iframe
                :src="iframeSrc"
                width="340"
                height="550px"
                frameborder="0"
                class="overflow-hidden"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div class="hidden md:block h-10 w-full bg-white"></div>
    </section>
  </div>
</template>

<script>
export default {
  name: "bannerView",
  data() {
    return {
      iframeSrc: "",
    };
  },
  created() {
    this.updateIframeSrc();
  },
  methods: {
    updateIframeSrc() {
      // Example logic to construct the full URL
      let newSrc = "https://jaroeducation.com/pages/jain-university/form/?";

      // Get URL parameters from the current URL
      const urlParams = new URLSearchParams(window.location.search);

      // Construct new URL with additional parameters or any required changes
      if (urlParams.has("utm_source")) {
        newSrc += `utm_source=${urlParams.get("utm_source")}&`;
      } else {
        newSrc += "";
      }

      if (urlParams.has("utm_medium")) {
        newSrc += `utm_medium=${urlParams.get("utm_medium")}&`;
      } else {
        newSrc += "";
      }

      if (urlParams.has("utm_campaign")) {
        newSrc += `utm_campaign=${urlParams.get("utm_campaign")}&`;
      } else {
        newSrc += "";
      }

      if (urlParams.has("utm_term")) {
        newSrc += `utm_term=${urlParams.get("utm_term")}`;
      } else {
        newSrc += "";
      }

      this.iframeSrc = newSrc;
    },
  },
};
</script>

<style></style>
